import React from 'react';

function Icon({ name, className = '', stokeWidth = 1.4 }) {
  const paths = {
    leftArrow: <path d="m6 3 5 5-5 5" />,
    calendar: (
      <>
        <rect x="2.5" y="3.5" width="11" height="10" rx="2" />
        <path d="M5 2v3M11 2v3M2.5 6.5h11M5.5 9h1M9.5 9h1M5.5 11.5h1" />
      </>
    ),
    shield: (
      <>
        <path d="M8 1.75 13.5 4v4.25c0 3.3-2.25 5.5-5.5 6.5-3.25-1-5.5-3.2-5.5-6.5V4L8 1.75Z" />
        <path d="m5.5 8 1.75 1.75L10.5 6.5" />
      </>
    ),
    store: (
      <>
        <path d="M2 6.5h12l-1.2-4H3.2L2 6.5ZM3 6.5v7h10v-7M6 13.5V9h4v4.5" />
        <path d="M2 6.5c0 1 .65 1.75 1.5 1.75S5 7.5 5 6.5c0 1 .65 1.75 1.5 1.75S8 7.5 8 6.5c0 1 .65 1.75 1.5 1.75S11 7.5 11 6.5c0 1 .65 1.75 1.5 1.75S14 7.5 14 6.5" />
      </>
    ),
    flask: (
      <>
        <path d="M6 1.75h4M7 1.75v4.5l-3.8 6.1a1.1 1.1 0 0 0 .94 1.65h7.72a1.1 1.1 0 0 0 .94-1.65L9 6.25v-4.5M5.2 10h5.6" />
      </>
    ),
    flame: (
      <>
        <path d="M8 1.5c.45 2.5-1.15 3.15-1.15 4.75 0 .8.5 1.35 1.15 1.35.95 0 1.6-.95 1.5-2.1 1.9 1.55 2.8 3.15 2.8 5.05a4.3 4.3 0 0 1-8.6 0c0-2.15 1.3-3.9 3.05-5.4C6.3 7.25 5.9 8.2 5.9 9c0 .65.4 1.1.95 1.1 1 0 1.7-1.1 1.15-2.35" />
      </>
    ),
    info: (
      <>
        <circle cx="8" cy="8" r="6.25" />
        <path d="M8 7v4M8 4.75h.01" />
      </>
    ),
    plus: (
      <>
        <path d="M8 3.5v9" />
        <path d="M3.5 8h9" />
      </>
    ),
    minus: <path d="M3.5 8h9" />
  };

  return (
    <svg
      className={className}
      aria-hidden="true"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={stokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {paths[name]}
    </svg>
  );
}

export default Icon;
